export const ROUTES = {
    HOME: "/",
    ROUTES_PREVIEW: "/routepreview",
    SIGN_IN: "/signin",
    ABOUT: "/#About",
    CONTACT: "/#Contact",
    BOOKNOW: "/#BookNow",
    SERVICES: "/#SERVICES",
    ROUTES_USER_TRIPS: "/trips",
    CHECK_OUT_PAGE: "/checkout"
}

export const BASE_URL = `${process.env.REACT_APP_API_URL}`